module.exports = __webpack_public_path__ + "static/allamimg-b067e288b74855dea671a0a7d7de9e72.jpg";